const initialState = {
    isAuthenticated: false,
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "USER_SET":
            return {
                ...state,
                ...action.data,
            };

        case "USER_UNSET":
            return {
                isAuthenticated: false,
            };
        default:
            return state;
    }
};

export default userReducer;
